export const documentType = doc => {
	if (doc === undefined || doc === null || doc === '') return null;
	if (doc.length === 11) return 'cpf';
	if (doc.length === 14) return 'cnpj';
	return null;
};
